import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AprobacionCliente } from '../validar-documentacion/aprobacionCliente.model';
import { MatSidenav } from '@angular/material';
import { SnackService } from '../../shared-services/snack.service';
import { ClienteService } from '../../core/cliente.service';

@Component({
  selector: 'app-usuario-panel-documentacion',
  templateUrl: './usuario-panel-documentacion.component.html',
  styleUrls: ['./usuario-panel-documentacion.component.scss']
})
export class UsuarioPanelDocumentacionComponent implements OnInit {

  @Input() lote: AprobacionCliente;
  @ViewChild('nav') nav: MatSidenav;
  constructor(
    clienteService: ClienteService,
    private snackService: SnackService
  ) { }

  ngOnInit() {
  }

  closeSidenav() {
    if (this.nav.mode === 'over') {
      this.nav.close();
    }
  }

  async showFile(id: number) {
  }
  private openWindow(data) {
    try {
      const blob = new Blob([data], { type: data.type });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '', 'width=400, height=400');
    } catch (ex) {
      console.log(ex);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-panel-documentacion/usuario-panel-documentacion.component.ts